'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    if (this.props.type === 'field') {
        theme.fontSize = theme.fieldFontSize;
        theme.lineHeight = theme.fieldLineHeight;
        theme.paddingTop = theme.fieldPaddingTop;
    } else if (this.props.type === 'form') {
        theme.textAlign = theme.formTextAlign;
        theme.margin = theme.formMargin;
        theme.background = theme.formBackground;
        theme.paddingTop = theme.formPaddingTop;
        theme.paddingBottom = theme.formPaddingBottom;
        theme.paddingLeft = theme.formPaddingLeft;
        theme.paddingRight = theme.formPaddingRight;
        theme.fontWeight = theme.twSemi;
        theme.fontSize = theme.formFontSize;
        theme.lineHeight = theme.formLineHeight;
    } else if (this.props.type === 'service') {
        theme.textAlign = theme.serviceTextAlign;
        theme.paddingTop = theme.servicePaddingTop;
        theme.paddingBottom = theme.servicePaddingBottom;
    } else if (this.props.type === 'global') {
        theme.fontSize = theme.globalFontSize;
        theme.lineHeight = theme.globalLineHeight;
        theme.textAlign = theme.globalTextAlign;
        theme.margin = theme.globalMargin;
    }

    var styleList = void 0;

    styleList = _aphroditeJss.StyleSheet.create({
        root: {
            color: theme.color,
            position: 'relative',
            textAlign: theme.textAlign,
            paddingTop: theme.paddingTop,
            paddingBottom: theme.paddingBottom,
            paddingLeft: theme.paddingLeft,
            paddingRight: theme.paddingRight,
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            fontWeight: theme.fontWeight,
            margin: theme.margin,
            width: theme.width,
            minWidth: theme.minWidth,
            background: theme.background,

            '& a': {
                color: theme.color,
                textDecoration: 'underline'
            }
        },
        formIcon: {
            width: theme.gutter * 3 + 'px',
            height: theme.gutter * 3 + 'px',
            background: 'url(' + _warning2.default + ') no-repeat center',
            backgroundSize: 'contain',
            flexShrink: 0,
            margin: '0 auto ' + theme.gutter / 2 + 'px auto'
        },
        formContent: {
            textAlign: 'center'
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        formContent: (0, _aphroditeJss.css)(styleList.formContent),
        formIcon: (0, _aphroditeJss.css)(styleList.formIcon)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var _warning = require('../img/warning.svg');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        color: theme.tError,
        textAlign: 'left',
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        fontSize: theme.tsNormal,
        lineHeight: theme.tlNormal,
        fontWeight: theme.twNormal,
        margin: 'auto',
        background: 'transparent',

        fieldFontSize: theme.tsXSmall,
        fieldLineHeight: theme.tlXSmall,
        fieldPaddingTop: theme.gutter + 'px',

        formMargin: 'auto auto ' + (theme.gutter * 3 + 'px') + ' auto',
        formTextAlign: 'center',
        formBackground: theme.elErrorLight,
        formPaddingTop: theme.gutter + 'px',
        formPaddingBottom: theme.gutter + 'px',
        formPaddingLeft: theme.gutter * 5 + 'px',
        formPaddingRight: theme.gutter * 5 + 'px',
        formFontSize: theme.tsSmall,
        formLineHeight: theme.tlSmall,

        serviceTextAlign: 'center',
        servicePaddingTop: theme.gutter * 4 + 'px',
        servicePaddingBottom: theme.gutter * 4 + 'px',

        globalTextAlign: 'center',
        globalFontSize: theme.tsLarge,
        globalLineHeight: theme.tlXLarge,
        globalMargin: '0 auto',
        width: 'auto',
        minWidth: 'auto'
    };
};